<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <app-Network></app-Network>
</ion-app>

<!-- <div class="container sp_screen_card">

  <div class="spsc_logo">

      <img src="assets/images/surgi_logo.svg" alt="">

  </div>

</div> -->